export const COLORS = [
  { color: '#e2c5c5', isDark: false },
  { color: '#deaaaa', isDark: false },
  { color: '#efc7a3', isDark: false },
  { color: '#efcca3', isDark: false },
  { color: '#efdea3', isDark: false },
  { color: '#d2efa3', isDark: false },
  { color: '#b7efa3', isDark: false },
  { color: '#a3efb8', isDark: false },
  { color: '#a3efdd', isDark: false },
  { color: '#b9eee1', isDark: false },
  { color: '#b9e8ee', isDark: false },
  { color: '#b9deee', isDark: false },
  { color: '#b9d1ee', isDark: false },
  { color: '#b9c1ee', isDark: false },
  { color: '#eeb9b9', isDark: false },
  { color: '#f7a8a8', isDark: false },
  { color: '#edaf76', isDark: false },
  { color: '#edc476', isDark: false },
  { color: '#ede176', isDark: false },
  { color: '#d5ed76', isDark: false },
  { color: '#a3ed76', isDark: false },
  { color: '#76ed9e', isDark: false },
  { color: '#b9bbee', isDark: false },
  { color: '#cab9ee', isDark: false },
  { color: '#dab9ee', isDark: false },
  { color: '#eab9ee', isDark: false },
  { color: '#eeb9d6', isDark: false },
  { color: '#eeb9c2', isDark: false },
  { color: '#bc5656', isDark: false },
  { color: '#e78239', isDark: false },
  { color: '#e7c039', isDark: false },
  { color: '#e7e039', isDark: false },
  { color: '#c4e739', isDark: false },
  { color: '#90e739', isDark: false },
  { color: '#39e740', isDark: false },
  { color: '#39e79e', isDark: false },
  { color: '#39e7e7', isDark: false },
  { color: '#39c7e7', isDark: false },
  { color: '#3993e7', isDark: true },
  { color: '#394ae7', isDark: true },
  { color: '#7b39e7', isDark: true },
  { color: '#c439e7', isDark: true },
  { color: '#c62424', isDark: false },
  { color: '#c66824', isDark: false },
  { color: '#c6ac24', isDark: false },
  { color: '#ddd51d', isDark: false },
  { color: '#96ca28', isDark: false },
  { color: '#33b628', isDark: false },
  { color: '#28b69c', isDark: false },
  { color: '#28adb6', isDark: true },
  { color: '#2894b6', isDark: true },
  { color: '#2872b6', isDark: true },
  { color: '#283eb6', isDark: true },
  { color: '#5528b6', isDark: true },
  { color: '#9128b6', isDark: true },
  { color: '#b6287d', isDark: true },
  { color: '#efefef', isDark: false },
  { color: '#ececec', isDark: false },
  { color: '#e5e5e5', isDark: false },
  { color: '#d4d4d4', isDark: false },
  { color: '#cccccc', isDark: false },
  { color: '#b1b1b1', isDark: false },
  { color: '#a0a0a0', isDark: false },
  { color: '#929292', isDark: false },
  { color: '#878383', isDark: true },
  { color: '#7e7e7e', isDark: true },
  { color: '#6c6c6c', isDark: true },
  { color: '#636363', isDark: true },
  { color: '#565656', isDark: true },
  { color: '#464646', isDark: true },
];
